export const ROUTES = {
  LOGIN: '/auth/login',
  VERIFY_LOGIN_OTP: '/auth/login/verify-otp',
  VERIFY_FORGOT_PASSWORD_OTP: '/auth/forgot-password/verify-otp',
  RESET_PASSWORD: '/auth/reset-password',
  TRANSACTION_LIST: '/transaction/list',
} as const;
